import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import InputLabel from "@mui/material/InputLabel";
// import OutlinedInput from "@mui/material/OutlinedInput";
// import MenuItem from "@mui/material/MenuItem";
// // import FormControl from "@mui/material/FormControl";
// import Select from "@mui/material/Select";
import {
  Autocomplete,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Grid,
  TextField,
} from "@common-ui/ui";

export default function DialogSelect(props) {
  const [open, setOpen] = React.useState(false);
  const [date, setDate] = React.useState("days");
  const [recurrence, setRecurrence] = React.useState("");
  const [oneTime, setOneTime] = React.useState(false);

  const handleChange = (event) => {
    if (event.target.name === "type_recurrence") {
      console.log("recurence");
      setRecurrence(event.target.value || "");
    } else if (event.target.name === "oneTime") {
      setOneTime(!oneTime);
    } else {
      setDate(event.target.value || "");
    }
  };
  React.useEffect(() => {
    if (recurrence === "") {
      return props.handleChangeGroup(false, true, `One Time`);
    }
    if (oneTime) {
      props.handleChangeGroup(false, true, `${recurrence} ${date}`);
    } else {
      props.handleChangeGroup(false, true, `Every ${recurrence} ${date}`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [recurrence, date, oneTime]);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = (event, reason) => {
    if (reason !== "backdropClick") {
      setOpen(false);

      props.setSelectedIndex(1);
    }
  };

  return (
    <div>
      <Button onClick={handleClickOpen} sx={{ mt: 1 }}>
        Add Recurrence
      </Button>
      <Dialog disableEscapeKeyDown open={open} onClose={handleClose}>
        <DialogTitle>Maintenance Interval</DialogTitle>
        <DialogContent>
          <Box component="form" sx={{ display: "flex", flexWrap: "wrap" }}>
            <Grid container spacing={2}>
              <Grid
                item
                xs={12}
                md={2.5}
                sx={{ display: "flex", flexWrap: "wrap" }}
              >
                <div sx={{ minWidth: 124 }}>
                  <InputLabel htmlFor="demo-dialog-native">#</InputLabel>{" "}
                  <TextField
                    // sx={{ m: 1 }}
                    disabled={oneTime}
                    size="small"
                    autoComplete="off"
                    placeholder="#"
                    type="number"
                    onChange={(e) => handleChange(e)}
                    // margin="normal"
                    name="type_recurrence"
                    // onChange={(e) => handleChangeGroup(e)}
                    // value={recurrence}
                    variant="outlined"
                  />
                </div>
              </Grid>
              <Grid item xs={12} md={7.5}>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6}>
                    <div sx={{ minWidth: 124 }}>
                      <InputLabel id="dialog-select-label">Every</InputLabel>
                      <Autocomplete
                        id="country-select"
                        disabled={oneTime}
                        // disablePortal
                        // disabled={!customers?.length}
                        ListboxProps={{ style: { maxHeight: "200px" } }}
                        options={[
                          { name: "Days", value: "days" },
                          { name: "Weeks", value: "weeks" },
                          { name: "Months", value: "months" },
                          { name: "Years", value: "years" },
                        ]}
                        sx={{ m: 0 }}
                        freeSolo
                        autoHighlight
                        onChange={(value, newValue) => {
                          setDate(newValue.value);
                        }}
                        size="small"
                        getOptionLabel={(option) => option?.name}
                        // margin="normal"
                        name="country"
                        limitTags={4}
                        fullWidth
                        renderOption={(props, option) => (
                          <Box
                            component="li"
                            sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                            {...props}
                          >
                            {option?.name}
                          </Box>
                        )}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="outlined"
                            placeholder="Add Text"
                            // margin="normal"
                            // sx={{ mt: 1 }}
                            inputProps={{
                              ...params.inputProps,
                              autoComplete: "off", // disable autocomplete and autofill
                            }}
                          />
                        )}
                      />
                    </div>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <div sx={{ minWidth: 124 }}>
                      <InputLabel
                        id="dialog-select-label"
                        sx={{ opacity: 0, m: 0 }}
                      >
                        Select
                      </InputLabel>
                      <FormGroup>
                        <FormControlLabel
                          control={<Checkbox />}
                          name="oneTime"
                          fullWidth
                          onChange={handleChange}
                          value={oneTime}
                          // fullWidth
                          label="One Time"
                        />
                      </FormGroup>
                    </div>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={handleClose}>Ok</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
